export const changeHolePageConfirm = 'changeHole:confirm';
export const eventChangeSocket = 'changeSocket:confirm';
export const eventChangeStrokeWidth = 'changeStrokeWidth:confirm';
export const eventChangeMultipleComponent = 'multipleComponent:confirm';
export const editImagePageConfirm = 'editImage:confirm';
export const changeBackgroundPageConfirm = 'change:background';
export const templateMutiImageBackgroundPageConfirm =
  'templateMutiImageBackground:confirm';
export const stickerRetouchPageConfirm = 'stickerRetouch:confirm';
export const whiteInkPageConfirm = 'whiteInk:confirm';
export const reversePrimerLayerPageConfirm = 'reversePrimerLayer:confirm';
export const scopeUvPageConfirm = 'scopeUv:confirm';
export const stampingPageConfirm = 'stamping:confirm';
export const retouchType_normal = 'normal';
export const retouchType_keyhole = 'keyhole';
export const retouchType_yakeli = 'yakeli';
export const retouchType_lipai = 'lipai';
export const subType_shape = 'SHAPE';
export const subType_head = 'HEAD';
export const subType_body = 'BODY';
export const subType_origin = 'ORIGIN';
export const subType_shapeBody = 'SHAPE_BODY';
export const useDefaultRetouch = 'useDefaultRetouch'; //  默认抠图
export const subType_shapeHead = 'SHAPE_HEAD';

export const tool_changeHole = 'changeHole'; // 改孔位
export const tool_outline = 'outline'; // 描边
export const tool_material = 'stickMaterial'; // 素材
export const hideMaterial = true; // 是否隐藏素材入口和素材弹窗
export const tool_manualRetouch = 'manualRetouch'; // 手动抠图
export const tool_changeImage = 'changeImage'; // 换图
export const tool_editImage = 'editImage'; // 编辑图片
export const tool_rotate = 'rotate'; // 旋转
export const tool_shape = 'shape'; // 刀线
export const tool_original = 'original'; // 原图
export const tool_fullBodyRetouch = 'fullBodyRetouch'; // 抠全身
export const tool_headRetouch = 'headRetouch'; // 只抠图
export const tool_retouch = 'retouch'; // 抠图
export const tool_noRetouch = 'noRetouch'; // 不抠图
export const tool_noRetouch1 = 'noRetouch1'; // 不抠图
export const tool_showRetouch = 'showRetouch'; // 显示抠图
export const tool_moveSocket = 'moveSocket'; // 移插口
export const tool_changeBg = 'changeBg'; // 换背景
export const tool_whiteInk = 'whiteInk'; // 白墨
export const tool_mainBody = 'mainBody'; // 主体
export const tool_frontWhiteInk = 'frontWhiteInk'; // 前白墨
export const tool_clear = 'clear'; // 清空
export const tool_upload = 'upload'; // 上传
export const tool_default = 'default'; // 默认
export const tool_uploadOutline = 'uploadOutline'; // 上传刀线
export const tool_template = 'template'; // 模板
export const tool_imageZindex = 'imageZindex'; // 图片置底
export const tool_setting = 'setting'; // 设置
export const tool_text = 'text'; // 文字
export const tool_zoomin = 'zoomin'; // 放大
export const tool_zoomout = 'zoomout'; // 缩小
export const tool_reverse = 'reverse'; // 逆向
export const tool_scopeUv = 'scopeUV'; // 局部uv
export const tool_component = 'component'; // 组件
export const tool_stamping = 'stamping'; // 烫色
export const tool_reversePrimerLayerAuto = 'reversePrimerLayerAuto'; // 逆向图层自动
export const tool_reversePrimerLayerFill = 'reversePrimerLayerFll'; // 逆向图层铺满
export const tool_changeSize = 'changeSize'; // 改尺寸
export const tool_stampingTemplate = 'stampingTemplate'; // 烫色模板
export const tool_stampingMaterial = 'stampingMaterial'; // 烫色素材
export const tool_stampingEffect = 'stampingEffect'; // 烫色效果

export const outlineLayerSkuBlockMessageMap = {
  multiUserImageWhiteInk: '当前存在多张用户图片，暂不支持编辑白墨',
  multiUserImageUploadOutline: '当前存在多张用户图片，暂不支持上传自定义刀线',
  missingUserImageWhiteInk: '素材图片暂不支持编辑白墨',
  missingUserImageUploadOutline: '素材图片暂不支持上传自定义刀线',
  editedWhiteInkUploadImage: '已编辑白墨，暂不支持继续上传图片',
  customOutlineUploadImage: '已上传自定义刀线，暂不支持继续上传图片'
};

export const editImageNewControlConfig = {
  userImageLayerControls: {
    showDeleteAndCopy: false,
    outlineLayerSkuShowDeleteAndCopy: true
  }
};

export const action_moveSocket = 'moveSocket'; // 移插口
export const action_changehole = 'changeHole';
export const action_changestrokewidth = 'changeStrokeWidth';
export const action_addComponent = 'addComponent'; // 添加组件

export const sticker_label_free = 'LABEL_FREE'; // 贴纸 自由排版
export const sticker_label_layout = 'LABEL_LAYOUT'; // 贴纸 阵列排版

// 边框常量（单位：毫米）
export const BORDER_WIDTH = {
  COLOR_PAPER: 1, // 色纸边框
  BAJI: 4, // 吧唧边框
  COLOR_PAPER_SHADOW: 1.3 // 实际测试: 不会使得预览图留白的保险的值
};

export const bleedMm = 1; // 裁剪区域外扩出血距离（单位：毫米）

// 位置常量
export const POSITION = {
  TOP_CENTER: 'TOP_CENTER',
  BOTTOM_CENTER: 'BOTTOM_CENTER',
  MAX_TOP: 'TOP',
  MAX_BOTTOM: 'BOTTOM'
};

// Layer 类型常量
export const layer_userImage = 'userImage'; // 用户原图类型
export const layer_template = 'template'; // SKU 模板类型
export const layer_skuMaterial = 'icon'; // SKU 素材类型
export const layer_background = 'background'; // 背景图类型
export const layer_transparentGrid = 'transparentGrid'; // 透明网格底图（仅用于编辑UI展示，不参与导出合成）
export const layer_stampingTemplate = 'foilTemplate'; // 烫色模板图层
export const layer_stampingMaterial = 'foilIcon'; // 烫色素材图层

export const backgroundDefaultOpacity = 0.45; // 背景默认透明度
export const backgroundDefaultOpacity_layer = 1; // 模板方案的背景透明度
export const isNoTranparentOpacity = 1; // 无透明底 SKU 的背景不透明度

export const backgroundMaxZIndex = -100; // type=background的图层 最大 zIndex
export const maxLayerZIndex = 100; // 图层中最大的层级
export const maxLayerCount = 20; // 最大图层个数
// 后台模板zIndex=-1时, 设置的初始zIndex,  为让 maxLayerCount 个layer 可以调整 zIndex 小于 type=skuTemplate 的 zIndex
export const minSkyTemplateZIndex = backgroundMaxZIndex + maxLayerCount;

export const transparentGridZIndex = -1000; // 透明网格底图的zIndex

export const emptyWhiteInk = 'EMPTY'; //  表示白墨清空
export const legacyEmptyWhiteInk = '-1'; // 兼容历史白墨清空值

export const whiteInkRgba = 'rgba(255,255,255,1)'; // 白墨RGBA颜色值

export const SNAP_ANGLE_CORRECTION_RANGE = 6; // 修正角度范围（度）
export const SNAP_POSITION_CORRECTION_RANGE = 3; // 位置修正范围（像素）

// skuType: https://www.showdoc.com.cn/xingbai/11558553171262098
export const subType_BADGE_LAMINATED = 'BADGE_LAMINATED_TEMPLATE'; // 模板覆膜吧唧
export const subType_SHAN = 'BADGE_SHAN_TEMPLATE'; //模板双闪吧唧
export const subType_BADGE_SHAN = 'BADGE_SHAN'; // 双闪吧唧
export const subType_COLOR_SHAN = 'COLOR_SHAN'; // 双闪色纸
export const subType_COLOR_LAMINATED = 'COLOR_LAMINATED'; // 覆膜色纸
export const subType_COLOR_JN = 'COLOR_JN'; // 透明色纸
export const subType_COLOR_ALPHA = 'COLOR_ALPHA'; // 透明色纸

export const subType_POSTER_ARR = ['POSTER', 'POSTER_REVERSE'];

export const subType_COLOR_ARR = [
  subType_COLOR_JN,
  subType_COLOR_ALPHA,
  subType_COLOR_SHAN,
  subType_COLOR_LAMINATED
]; // 色纸\透明色纸 \双闪

// 吧唧
export const subType_BAJI_ARR = [
  subType_BADGE_LAMINATED,
  subType_SHAN,
  'BADGE_LAMINATED',
  subType_BADGE_SHAN
];

// 覆膜吧唧
export const subType_LAMINATED_ARR = [
  subType_BADGE_LAMINATED,
  'BADGE_LAMINATED'
];

export const subType_FLASH_BOTTOM_ARR = [
  subType_BADGE_SHAN,
  subType_COLOR_SHAN
];

// 添加白底的 sku
export const ADD_WHITE_SKU_ARR = [subType_BADGE_LAMINATED, 'COLOR_JN'];

export function isTemplateBaji(subType) {
  return subType_BAJI_ARR.indexOf(subType) > -1;
}

// 色纸
export function isTemplateColorPaper(subType) {
  return subType_COLOR_ARR.indexOf(subType) > -1;
}

// 判断模板sku中是否需要跳转 previewColorPaperNew 页面进行后续处理
export function isTemplateSkuWithColorPaper(subType) {
  return [...subType_COLOR_ARR, ...subType_BAJI_ARR].indexOf(subType) > -1;
}

// 可以跳过后续处理页面
export function isSkipPreviewStep(subType) {
  return (
    [subType_COLOR_JN, subType_COLOR_ALPHA, subType_BADGE_LAMINATED].indexOf(
      subType
    ) > -1
  );
}

export const whiteInkFilterAlpha = 0.7 * 255; // 白墨过滤透明度
export const maxUploadImageSize = 25 * 1024 * 1024; // 图片上传最大大小（25MB）
export const whiteInkUploadSupportImageTypeList = [
  'jpg',
  'png',
  'jpeg',
  'heic',
  'webp'
]; // 白墨上传支持的图片格式

export const skuTemplate = 'skuTemplate';

export const liPaiDefaultOutline = [[0, 0]]; // 立牌默认的outline

export const multiplier = 2;

export const WhiteActionMap = {
  BODY: 'BODY',
  EMPTY: 'EMPTY',
  CUSTOMIZE: 'CUSTOMIZE',
  DEFAULT: 'DEFAULT',
  MODIFY: 'MODIFY'
};

export const whiteModeMap = {
  NO_BUTTON: 0, // 没有白墨按钮
  DEFAULT: 1, // 默认前景白墨
  EMPTY: 2 // 默认无白墨
};

/**
 * 获取当前 SKU 对应的用户图白墨初始化重置数据。
 * @param {Object} skuTemplate - 当前 SKU 模板信息。
 * @returns {Object} 白墨重置数据。
 */
export function getInitialWhiteInkResetData(skuTemplate) {
  const isDefaultEmptyWhiteInk =
    skuTemplate && skuTemplate.whiteMode == whiteModeMap.EMPTY;
  return {
    whiteInk: isDefaultEmptyWhiteInk ? emptyWhiteInk : undefined,
    whiteInkOriginImageSrc: undefined,
    whiteAction: '',
    whiteShrink: true
  };
}

// 逆向层的操作
export const ReversePrimerLayerActionMap = {
  AUTO: 'AUTO', // 自动
  EMPTY: 'EMPTY', // 清空
  CUSTOMIZE: 'CUSTOMIZE', // 上传
  FILL: 'FILL' // 铺满
};

// 局部UV的操作
export const ScopeUvActionMap = {
  CUSTOMIZE: 'CUSTOMIZE',
  EMPTY: 'EMPTY' // 清空
};

// 图层的 key 常量,
export const LayerKeyMap = {
  LAYERS: 'layers', // 正面图层
  REVERSE_LAYER: 'reverseLayer' // 反面图层
};

/** 反面 outline 相关字段默认值（重置/清空时使用） */
export const REVERSE_OUTLINE_DEFAULTS = {
  reverseOutlineImageSrc: '',
  reverseOutlineOriginImageSrc: '',
  reverseOutlineOriginImageFileName: '',
  reverseNoOutlineImageSrc: ''
};

// skuTemplate.defaultPage（属性名与字符串值一致，同 miniAppWebBridgeMap 约定）
export const SkuTemplateDefaultPageMap = {
  segment: 'segment',
  segment_body: 'segment_body',
  segment_head: 'segment_head',
  shape: 'shape'
};

// 路由/参数 skuType（与 serviceHoleNew DRAW_TYPE 字面量一致）
export const SkuTypeMap = {
  liPai: 'liPai',
  keyHole: 'keyHole',
  normal: 'normal'
};

// 图片在画布中的布局类型（createLayerInfoFromImageUrl / calcImageInCanvasPosition 等）
export const ImageLayoutTypeMap = {
  fit: 'fit',
  fill: 'fill',
  fitRemoveTransparent: 'fitRemoveTransparent'
};

// help-alt 组件 helpAltType（fit/fill 与 ImageLayoutTypeMap 同源）
export const HelpAltTypeMap = {
  fit: 'fit',
  fill: 'fill',
  lipai: 'lipai',
  paster: 'paster',
  holeAlt: 'holeAlt',
  key: 'key',
  noStroke: 'noStroke',
  holeSizeAlt1: 'holeSizeAlt1',
  holeSizeAlt2: 'holeSizeAlt2',
  outline_multiple: 'outline_multiple',
  outline_notfill: 'outline_notfill'
};

// 小程序与 H5 通信约定：wxData.action、postMessage.data.type 等（键值需与小程序端保持一致）
export const miniAppWebBridgeMap = {
  clearData: 'clearData',
  importThirdOrder: 'importThirdOrder',
  addMyWork: 'addMyWork',
  submitPrint: 'submitPrint',
  importOrder: 'importOrder',
  reLogin: 'reLogin'
};

// 刀线颜色
export const outlineColor = 'rgb(230,0,18)';
// const lineColor =  'rgba(0,0,0,0.05)';

export const renderScale = 10;

export const maxCanvasWidth = 8000; // canvas 最大宽度
export const maxCanvasHeight = 8000;

export const whiteInkTypeMap = {
  EMPTY: 'EMPTY',
  DEFAULT: 'DEFAULT'
};

/**
 * 判断 whiteInk 是否为清空白墨值，兼容历史 -1。
 * @param {*} whiteInk - 图层 whiteInk 字段值
 * @returns {boolean} 是否为清空白墨
 */
export function isClearWhiteInkValue(whiteInk) {
  return (
    whiteInk == emptyWhiteInk ||
    whiteInk == legacyEmptyWhiteInk ||
    whiteInk == whiteInkTypeMap.EMPTY
  );
}

/**
 * 判断 whiteInk 是否为默认有白墨值。
 * @param {*} whiteInk - 图层 whiteInk 字段值
 * @returns {boolean} 是否为默认有白墨
 */
export function isDefaultWhiteInkValue(whiteInk) {
  return (
    whiteInk === undefined ||
    whiteInk === null ||
    whiteInk === '' ||
    whiteInk == whiteInkTypeMap.DEFAULT
  );
}
